import React from 'react'
import './card-icon.css'

const CardIcon = props => {
    const valueStyle = {
        fontSize: props.data.value.length > 7 ? '22px' : null
    }
    return (
        <div className='card-icon-container'>
            <span className='card-icon-title'>{props.data.label}</span>

            <div className='card-icon-content'>

                <div className='card-icon-box'>
                    <div style={{ backgroundImage: `url('${props.data.icon}')` }} className='card-icon-iten' />
                </div>
                <div className='card-icon-value-content'>
                    <span className='card-icon-value' style={valueStyle}>{props.data.value}</span> 

                </div>
            </div>
        </div>
    )
}

export default CardIcon